// Core
import { useState, useEffect } from 'react';
import { RiShieldUserFill } from 'react-icons/ri';
import { PiUserFocusThin } from "react-icons/pi";
import { GiProgression } from "react-icons/gi";
import { AiFillStar } from 'react-icons/ai';
import { GrAnalytics } from "react-icons/gr";
import { PiGarageFill } from 'react-icons/pi';
import { MdToken } from 'react-icons/md';
import { SiSpeedtest } from 'react-icons/si';
import { IoIosSettings } from 'react-icons/io';
import { TbLayoutDashboard } from 'react-icons/tb';
import { FaOilCan } from "react-icons/fa";
import { BiSolidSprayCan } from "react-icons/bi";
import { FaCar } from "react-icons/fa";
import { FaArrowsLeftRight } from "react-icons/fa6";
import { FaTelegramPlane } from "react-icons/fa";
import { FaArrowRotateRight } from "react-icons/fa6";
import { FaStar } from "react-icons/fa";

// Chakra 
import { 
  Box,
  Button,
  Divider,
  Image,
  Flex, 
  Grid,
  FormControl,
  FormLabel,
  FormHelperText,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Spinner,
  Text, 
  useToast,
  useColorModeValue,
  useDisclosure
} from '@chakra-ui/react';

// Components
import roadSh from '../../../assets/road-sh.png';

const MarketModal = ({ 
  tokens, 
  allTokens,
  isOpen, onOpen, onClose
}) => {
  const bgBtn = '#f3c513';
  const textColor = '#8b5109';

  const products = [
    {
      tokens: 10,
      stars: 1,
      ton: 0.01
    },
    {
      tokens: 20,
      stars: 2,
      ton: 0.02
    },
    {
      tokens: 100,
      stars: 10,
      ton: 0.1
    },
    {
      tokens: 150,
      stars: 15,
      ton: 0.15,
    }
  ];

  const toast = useToast();
  const handleBuyTokens = (amount) => {
    const product = products.find(p => p.stars === amount);
    if(!product) { return };

    if (!window.Telegram || !Telegram.WebApp.initDataUnsafe) {
      toast({
        title: "Error",
        description: "Telegram WebApp is not initialized.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const request = {
      currency: "STARS",
      amount, 
      payload: JSON.stringify({
          slug: 'gameStartPay',
          tokens: product.tokens
      })
    };

    Telegram.WebApp.openInvoice(request);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent className="modal__simple modal__blue" maxW={{ sm: '100%' }} mb="160px">
      <ModalHeader display="flex" alignItems="left" justifyContent="left">Market</ModalHeader>
        <ModalCloseButton />
        <ModalBody>

          <Grid 
            alignItems="left" 
            justifyItems="left"
            m="20px 0 10px 0"
            gap="12px"
            templateColumns="1fr 1fr">

            { products?.map((item) => (
              <Box 
                bg={`url(${roadSh}) #131313 no-repeat`}
                backgroundSize="cover"
                backgroundPosition="center"
                padding="20px 20px"
                borderRadius="10px"
                border="1px solid #2d2d2d"
                textAlign="center"
                w="100%">

                <Text variant="title-lg">{item.tokens} tokens</Text>

                <MdToken fontSize="124px" style={{ margin: '16px auto'}} />

                <Button 
                  onClick={() => handleBuyTokens(item.stars)}
                  bg={bgBtn}>
                  <Text variant="title-lg" color={textColor}>{item.stars}</Text>
                  <FaStar fontSize="24px" fill={textColor} color="white" style={{ margin: '-3px 0 0 6px'}} />
                </Button>

              </Box>
            ))}
          
          </Grid>

        </ModalBody>
      </ModalContent>
    </Modal> 
  );
};

export default MarketModal;